import { addProductSchema } from '../schema/addProductSchema'
import { getData } from '../assets/scripts/GeneralFunctions'
import { toast } from 'react-toastify'
import { errorList } from './stateList'

export const addProductSubmitHandler = async (
  category,
  setIsSubmit,
  inputs,
  setUserResult,
  setError,
  error,
  products,
  setProducts,
  setShowModal
) => {
  setIsSubmit(true)

  try {
    const validatedInputs = await addProductSchema.validate(inputs, { abortEarly: false })
    let queryParams = {
      name: validatedInputs?.name,
      product: validatedInputs?.product,
      category,
    }

    const apiResult = await getData(
      `admin/site-options/products/create`,
      'post',
      queryParams,
      true,
      true
    )
    if (apiResult?.status === 200) {
      setIsSubmit(false)
      setShowModal(false)
      setProducts([apiResult?.data?.product, ...products])
      toast.success('موفقیت آمیز')
    } else {
      setError(apiResult?.error)
    }
  } catch (err) {
    setError({
      ...error,
      ...errorList(err),
    })
  } finally {
    setIsSubmit(false)
  }
}

export const addCarCategorySubmitHandler = async (
  categoryName,
  carModels,
  setCarModels,
  setIsSubmit,
  setError,
  error,
  setShowModal
) => {
  setIsSubmit(true)

  try {
    let queryParams = {
      model: categoryName,
    }

    const apiResult = await getData(
      `admin/site-options/car-models/create`,
      'post',
      queryParams,
      true
    )
    if (apiResult?.status === 200) {
      setIsSubmit(false)
      setShowModal(false)
      setCarModels([apiResult?.data?.car_model, ...carModels])
      toast.success('با موفقیت افزوده شد')
    } else {
      setError(apiResult?.error)
    }
  } catch (err) {
    setError({
      ...error,
      ...errorList(err),
    })
  } finally {
    setIsSubmit(false)
  }
}
